<template>
  <div class="admin-wrapper">
    <aside class="sidebar">
      <div class="sidebar-header">
      <div class="logo-icon">
        <img src="/logo.png" alt="Logo" class="logo-img">
      </div>
      <span class="logo-text">后台管理</span>
    </div>
      <nav class="sidebar-nav">
        <router-link to="/im_admin/user" class="nav-item" :class="{ active: $route.path === '/im_admin/user' }">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </router-link>
        <router-link to="/im_admin/invitation" class="nav-item" :class="{ active: $route.path === '/im_admin/invitation' }">
          <i class="ri-ticket-line"></i>
          <span>邀请码管理</span>
        </router-link>
        <router-link to="/im_admin/group" class="nav-item" :class="{ active: $route.path === '/im_admin/group' }">
          <i class="el-icon-chat-line-square"></i>
          <span>群聊管理</span>
        </router-link>
        <div class="nav-group">
          <button class="nav-item nav-group-toggle" @click="systemMenuOpen = !systemMenuOpen">
            <i class="el-icon-setting"></i>
            <span>系统管理</span>
            <i class="el-icon-arrow-down toggle-arrow" :class="{ rotated: systemMenuOpen }"></i>
          </button>
          <div class="submenu" v-show="systemMenuOpen">
            <router-link to="/im_admin/system" class="submenu-item" :class="{ active: $route.path === '/im_admin/system' }">
              系统配置
            </router-link>
            <router-link to="/im_admin/password" class="submenu-item" :class="{ active: $route.path === '/im_admin/password' }">
              修改密码
            </router-link>
            <router-link to="/im_admin/logs" class="submenu-item" :class="{ active: $route.path === '/im_admin/logs' }">
              系统日志
            </router-link>
            <router-link to="/im_admin/stats" class="submenu-item" :class="{ active: $route.path === '/im_admin/stats' }">
              数据统计
            </router-link>
          </div>
        </div>
      </nav>
    </aside>

    <div class="main-wrapper">
      <header class="top-header">
        <div class="header-left">
          <h2 class="page-title">{{ pageTitle }}</h2>
        </div>
        <div class="header-right">
          <div class="admin-info">
            <div class="admin-avatar">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="admin-detail">
              <span class="admin-name">{{ adminInfo?.name || '超级管理员' }}</span>
              <span class="admin-role">SUPER ADMIN</span>
            </div>
          </div>
          <div class="divider"></div>
          <button class="logout-btn" @click="handleLogout">
            <i class="el-icon-switch-button"></i>
            <span>退出登录</span>
          </button>
        </div>
      </header>

      <main class="content-area">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminIndex',
  data() {
    return {
      adminInfo: null,
      systemMenuOpen: true
    }
  },
  computed: {
    pageTitle() {
      const routeMap = {
        '/im_admin/user': '用户管理',
        '/im_admin/invitation': '邀请码管理',
        '/im_admin/group': '群聊管理',
        '/im_admin/system': '系统配置',
        '/im_admin/password': '修改密码',
        '/im_admin/logs': '系统日志',
        '/im_admin/stats': '数据统计'
      }
      return routeMap[this.$route.path] || '后台管理'
    }
  },
  mounted() {
    this.loadAdminInfo()
  },
  methods: {
    async loadAdminInfo() {
      try {
        const response = await this.$http({
          url: '/admin/info',
          method: 'get'
        })
        this.adminInfo = response
      } catch (error) {
        console.error('获取管理员信息失败', error)
      }
    },
    handleLogout() {
      localStorage.removeItem('adminToken')
      this.$router.push('/im_admin/login')
    }
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css');

.admin-wrapper {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
}

.sidebar {
  width: 256px;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
}

.sidebar-header {
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #f5f5f5;
}

.logo-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.sidebar-nav {
  flex: 1;
  padding: 16px 0;
  overflow-y: auto;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  transition: all 0.15s;
  border-right: 3px solid transparent;
}

.nav-item i:first-child {
  margin-right: 12px;
  font-size: 18px;
}

.nav-item:hover {
  background: #f1f5f9;
  color: #07c160;
}

.nav-item.active {
  background: #f1f5f9;
  color: #07c160;
  border-right-color: #07c160;
}

.nav-group {
  margin-top: 8px;
}

.nav-group-toggle {
  width: 100%;
  justify-content: flex-start;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}

.toggle-arrow {
  margin-left: auto;
  font-size: 12px;
  transition: transform 0.2s;
}

.toggle-arrow.rotated {
  transform: rotate(180deg);
}

.submenu {
  background: #f8fafc;
}

.submenu-item {
  display: block;
  padding: 10px 24px 10px 56px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  transition: color 0.15s;
}

.submenu-item:hover {
  color: #07c160;
}

.submenu-item.active {
  color: #07c160;
}

.main-wrapper {
  flex: 1;
  margin-left: 256px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.top-header {
  height: 64px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  position: fixed;
  top: 0;
  left: 256px;
  right: 0;
  z-index: 50;
}

.header-left {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.admin-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-avatar {
  width: 32px;
  height: 32px;
  background: #ecfdf5;
  border: 1px solid #d1fae5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #07c160;
  font-size: 16px;
}

.admin-detail {
  display: flex;
  flex-direction: column;
}

.admin-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
}

.admin-role {
  font-size: 10px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.divider {
  width: 1px;
  height: 24px;
  background: #e2e8f0;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: color 0.15s;
}

.logout-btn:hover {
  color: #ef4444;
}

.logout-btn i {
  font-size: 18px;
}

.content-area {
  flex: 1;
  padding: 32px;
  margin-top: 64px;
  overflow-y: auto;
  background: #f8fafc;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #cbd5e1;
}
</style>